import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import './style.css';

const TopHeader = () => {
  return (
    <div className="home-top-header">

      <div className="top-header-details">
        <div className="top-header-email">
          <FontAwesomeIcon icon={faEnvelope} className="top-social-icon" />
          <h3>tripanddroptravels@gmail.com</h3>
        </div>

        <div className="top-header-phone">
          <FontAwesomeIcon icon={faPhone} style={{ color: 'white' }} className="top-social-icon" />
          <h3>+91 9999116868</h3>
        </div>
      </div>

      <div className="top-social">
        <h3>Follow Us :</h3>
        <a href="https://www.facebook.com/tripanddroptravels/" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faFacebook} />
        </a>
        <a href="https://www.instagram.com/tripanddroptravels/" target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
      </div>

    </div>
  );
};

export default TopHeader;
